import { JobCandidatesFunnel } from "../../types";
import { JobCandidatesFunnelResponse } from "../controllers/jobs";

export const convertJobCandidatesFunnelResponse = (
    jobCandidatesFunnelResponse: JobCandidatesFunnelResponse
): JobCandidatesFunnel => {
    const result: JobCandidatesFunnel = {
        newAndQualifyingCandidateCount:
            jobCandidatesFunnelResponse.newAndQualifyingCandidateCount,
        reviewCandidateCount: jobCandidatesFunnelResponse.reviewCandidateCount,
        submittedCandidateCount:
            jobCandidatesFunnelResponse.submittedCandidateCount,
        uniqueSubmittedCandidateCount:
            jobCandidatesFunnelResponse.uniqueSubmittedCandidateCount,
        interviewingCandidateCount:
            jobCandidatesFunnelResponse.interviewingCandidateCount,
        offeredCandidateCount:
            jobCandidatesFunnelResponse.offeredCandidateCount,
        rejectedCandidateCount:
            jobCandidatesFunnelResponse.rejectedCandidateCount,
        uniqueRejectedFromSubmittedPlusCandidateCount:
            jobCandidatesFunnelResponse.uniqueRejectedFromSubmittedPlusCandidateCount,
        hiredCandidateCount: jobCandidatesFunnelResponse.hiredCandidateCount,
    };

    return result;
};
